import { useEffect, useState } from "react";
import { requestPersonalGoalEarnings } from "@/apps/goals/services/goalsApi";
import { GoalEarnings } from "@/apps/goals/types";

export const useGoalEarnings = (yandexId: string | null) => {
  const [earnings, setEarnings] = useState<GoalEarnings | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!yandexId) return;

    let ignoreResult = false;

    setIsLoading(true);

    requestPersonalGoalEarnings(yandexId)
      .then((nextEarnings) => {
        if (ignoreResult) return;

        setEarnings(nextEarnings);
      })
      .catch(() => undefined)
      .finally(() => {
        if (ignoreResult) return;

        setIsLoading(false);
      });

    return () => {
      ignoreResult = true;
    };
  }, [yandexId]);

  return {
    earnings,
    setEarnings,
    isLoading,
  };
};
